<template>
    <div>
        <h2>Мероприятия</h2>
        <div class="main__items">
            <div v-for="item of itemsToShow" :key="item.id" class="main__item">
                <div class="main__item-name">
                    <router-link :to="`/expert-panel/review/${item.id}`">{{ item.name }}</router-link>
                </div>
                <div class="main__item-period">{{ item.period }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import {rusDateTime} from "@/tools/date_format";

export default {
    name: "ExpertPanelMain",
    props: {
        items: Array,
    },
    computed: {
        itemsToShow() {
            return this.items.map((item) => {
                return {
                    ...item,
                    period: [item.startAt, item.endAt]
                        .map(rusDateTime)
                        .join(' — '),
                };
            });
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/styles/rem';

h2 {
  font-weight: 700;
  font-size: rem(24);
  line-height: rem(34);
  margin: rem(40) 0;
}

.main {
  &__items {
    display: flex;
    flex-direction: column;
    gap: rem(40);
  }
  &__item {

  }
  &__item-name {
    font-weight: 600;
    font-size: rem(16);
    line-height: rem(24);
    margin-bottom: rem(12);
  }
  &__item-period {
    color: #98A0A9;
    font-weight: 600;
    font-size: rem(16);
    line-height: rem(24);
  }
}
</style>